export class YamlConstants {
    public static isYamlProperty = "isYaml";
}